export const dataAniversarioFields = [
    {
        "key": "IDDataAniversario",
        "label": "ID Data Aniversário"
    },
    {
        "key": "IDFluxoEvento",
        "label": "ID Fluxo Evento"
    },
    {
        "key": "DataReferencia",
        "label": "Data Referência"
    },
    {
        "key": "DataAniversarioAnterior",
        "label": "Data Aniversário Anterior"
    },
    {
        "key": "DataAniversario",
        "label": "Data Aniversário"
    },
    {
        "key": "CorrigeDataAniversario",
        "label": "Corrige Data Aniversário"
    },
    {
        "key": "AniversarioPeriodico",
        "label": "Aniversário Periódico"
    }
]